// AcademyPage-v1.1.0.jsx - Version: 1.1.0 - Created: 2024-12-08
import React, { useState } from 'react'
import { getLessonsByLevel } from '../../data/lessons/all-lessons.js'
import './AcademyPage-v1.1.0.css'

const AcademyPage = () => {
  const [selectedLevel, setSelectedLevel] = useState('beginner')
  const [selectedLesson, setSelectedLesson] = useState(null)
  const [viewMode, setViewMode] = useState('list') // 'list' or 'lesson'

  const levels = [
    { id: 'beginner', name: 'مبتدی', icon: '👶', color: '#4FC3F7' },
    { id: 'intermediate', name: 'متوسط', icon: '🚀', color: '#81C784' },
    { id: 'advanced', name: 'پیشرفته', icon: '🏆', color: '#FFB74D' }
  ]

  const currentLessons = getLessonsByLevel(selectedLevel)

  const handleStartLesson = (lesson) => {
    setSelectedLesson(lesson)
    setViewMode('lesson')
  }

  const handleBackToList = () => {
    setViewMode('list')
    setSelectedLesson(null)
  }

  // تابع برای نمایش محتوای درس
  const renderLessonContent = () => {
    if (!selectedLesson) return null

    return (
      <div className="lesson-content-view">
        <button className="back-button" onClick={handleBackToList}>
          ← بازگشت به لیست دروس
        </button>
        
        <div className="lesson-details">
          <header className="lesson-header">
            <h1>{selectedLesson.title}</h1>
            <p>{selectedLesson.description}</p>
            <div className="lesson-meta">
              <span>⏱️ {selectedLesson.duration}</span>
              <span>📚 سطح: {selectedLesson.level}</span>
              <span>🎯 درس {selectedLesson.order}</span>
            </div>
          </header>

          <section className="content-section">
            <h2>📖 مطالب آموزشی</h2>
            <div 
              className="lesson-text"
              dangerouslySetInnerHTML={{ 
                __html: selectedLesson.content.text.replace(/\n/g, '<br/>') 
              }}
            ></div>
          </section>

          {selectedLesson.content.exercises.length > 0 && (
            <section className="exercises-section">
              <h2>🎯 تمرین‌ها</h2>
              <div className="exercises-list">
                {selectedLesson.content.exercises.map((exercise, index) => (
                  <div key={exercise.id} className="exercise-card">
                    <div className="exercise-header">
                      <span className="exercise-number">تمرین {index + 1}</span>
                      <span className="exercise-type">
                        {exercise.type === 'quiz' ? '❓ آزمون' : '📝 تمرین'}
                      </span>
                    </div>
                    
                    <div className="exercise-content">
                      <h4>{exercise.title || exercise.question}</h4>
                      
                      {exercise.type === 'quiz' && (
                        <div className="quiz-options">
                          {exercise.options.map((option, optIndex) => (
                            <label key={optIndex} className="option">
                              <input type="radio" name={`quiz-${exercise.id}`} />
                              {option}
                            </label>
                          ))}
                          <button className="check-answer primary-button">
                            بررسی پاسخ
                          </button>
                        </div>
                      )}
                      
                      {exercise.explanation && (
                        <div className="exercise-explanation">
                          <strong>💡 راهنمایی:</strong> {exercise.explanation}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          <section className="lesson-actions">
            <button className="primary-button large">
              ✅ علامت‌گذاری به عنوان تکمیل شده
            </button>
          </section>
        </div>
      </div>
    )
  }

  // اگر در حالت مشاهده درس هستیم
  if (viewMode === 'lesson' && selectedLesson) {
    return (
      <div className="academy-page">
        <div className="academy-container">
          {renderLessonContent()}
        </div>
      </div>
    )
  }

  // حالت عادی (لیست دروس)
  return (
    <div className="academy-page">
      <div className="academy-container">
        {/* هدر آکادمی */}
        <header className="academy-header">
          <h1>آکادمی شطرنج</h1>
          <p>یادگیری مرحله به مرحله شطرنج از پایه تا پیشرفته</p>
        </header>

        {/* سطوح آموزشی */}
        <section className="levels-section">
          <h2>سطح آموزشی خود را انتخاب کنید</h2>
          <div className="levels-grid">
            {levels.map(level => (
              <div
                key={level.id}
                className={`level-card ${selectedLevel === level.id ? 'active' : ''}`}
                onClick={() => setSelectedLevel(level.id)}
                style={{ borderColor: level.color }}
              >
                <div className="level-icon" style={{ color: level.color }}>
                  {level.icon}
                </div>
                <h3>{level.name}</h3>
                <div className="lesson-count">
                  {getLessonsByLevel(level.id).length} درس
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* دروس سطح انتخاب شده */}
        <section className="lessons-section">
          <div className="section-header">
            <h2>دروس سطح {levels.find(l => l.id === selectedLevel)?.name}</h2>
            <div className="lessons-count">
              {currentLessons.length} درس موجود
            </div>
          </div>

          {currentLessons.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📚</div>
              <h3>هنوز درسی برای این سطح ایجاد نشده</h3>
              <p>به زودی دروس جدید اضافه خواهند شد</p>
            </div>
          ) : (
            <div className="lessons-grid">
              {currentLessons.map(lesson => (
                <div key={lesson.id} className="lesson-card">
                  <div className="lesson-header">
                    <div className="lesson-icon">
                      {lesson.type === 'video' ? '🎬' : '📖'}
                    </div>
                    <div className="lesson-meta">
                      <span className="lesson-duration">⏱️ {lesson.duration}</span>
                      <span className="lesson-level">سطح: {lesson.level}</span>
                    </div>
                  </div>

                  <div className="lesson-content">
                    <h3 className="lesson-title">{lesson.title}</h3>
                    <p className="lesson-description">{lesson.description}</p>
                    
                    <div className="lesson-objectives">
                      <strong>اهداف یادگیری:</strong>
                      <ul>
                        {lesson.objectives.map((objective, index) => (
                          <li key={index}>• {objective}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="lesson-features">
                      <span className="feature">
                        📖 متن آموزشی
                      </span>
                      {lesson.content.exercises.length > 0 && (
                        <span className="feature">
                          🎯 {lesson.content.exercises.length} تمرین
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="lesson-footer">
                    {lesson.locked ? (
                      <button className="locked-button" disabled>
                        🔒 قفل شده
                      </button>
                    ) : (
                      <button 
                        className="start-button primary-button"
                        onClick={() => handleStartLesson(lesson)}
                      >
                        شروع درس
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  )
}

export default AcademyPage